import React from "react";

const Footer = () => {
  return (
    <div className="bg-gray-800 text-sm p-4 text-center text-white">
      Copyright © 2022 Rajkumar vishwakarma.All Rights reserved.
    </div>
  );
};

export default Footer;
